import { render, staticRenderFns } from "./MetaRel.vue?vue&type=template&id=d0f57ba0&scoped=true&"
import script from "./MetaRel.vue?vue&type=script&lang=js&"
export * from "./MetaRel.vue?vue&type=script&lang=js&"
import style0 from "@/assets/fluid-wider.css?vue&type=style&index=0&id=d0f57ba0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0f57ba0",
  null
  
)

export default component.exports